
import NavBar from "@/components/NavBar.vue";
import NewHeaderSection from "@/components/NewHeaderSection.vue";
import FooterSection from "@/components/FooterSection.vue";

import { ref, onMounted, onBeforeMount } from "vue";

export default {
  name: "LandingPage",
  components: {
    NavBar,
    NewHeaderSection,
    FooterSection,
  },
  setup() {
    const windowSize = ref(0);
    const scrollPosition = ref(0);

    function updateScroll() {
      scrollPosition.value = window.scrollY;
    }

    onMounted(() => {
      window.addEventListener("scroll", updateScroll);
    });

    onBeforeMount(() => {
      windowSize.value = window.innerWidth;
    }),
      window.addEventListener("resize", () => {
        windowSize.value = window.innerWidth;
      });

    return {
      scrollPosition,
      updateScroll,
      windowSize,
    };
  },
};
